import React, { useEffect, useState } from "react";

// Skeleton for the "Rapport hebdo" tab while data loads.
// Mirrors: 3 metric cards + a few list sections.
//
// Le rapport est long à charger : l'endpoint coach/weekly-report enchaîne quatre
// requêtes PAR ÉLÈVE — séances de la semaine, dernière séance, objectif,
// ressentis — puis deux agrégats sur la semaine précédente. Avec une
// vingtaine d'élèves l'attente se compte en secondes, et un squelette immobile
// finit par ressembler à une page figée.
//
// D'où ces messages, qui suivent l'ordre réel des requêtes plutôt que d'égrener
// des formules creuses : ce que le coach lit correspond à ce que le serveur est
// en train de faire.
const ETAPES = [
	"Récupération de tes élèves…",
	"Comptage des séances de la semaine…",
	"Lecture des ressentis…",
	"Comparaison avec la semaine précédente…",
	"Mise en forme du rapport…",
];

const INTERVALLE_MS = 2200;

export default function WeeklyReportSkeleton() {
	const [etape, setEtape] = useState(0);

	useEffect(() => {
		// On avance jusqu'au dernier message puis on s'y arrête, sans boucler :
		// repartir au début laisserait croire que le chargement a recommencé. Le
		// point qui bat continue d'indiquer l'activité.
		const minuteur = setInterval(() => {
			setEtape((i) => (i < ETAPES.length - 1 ? i + 1 : i));
		}, INTERVALLE_MS);
		return () => clearInterval(minuteur);
	}, []);

	return (
		<div className="weekly-skeleton" aria-busy="true" aria-label="Chargement du rapport hebdo">
			<div className="weekly-loader-statut">
				<span className="weekly-loader-point" aria-hidden="true" />
				{/* key sur l'index : remonter le nœud à chaque changement relance
				    l'animation d'apparition, qu'un simple changement de texte ne
				    déclencherait pas. */}
				<span key={etape} className="weekly-loader-texte" aria-live="polite">
					{ETAPES[etape]}
				</span>
			</div>

			<div className="weekly-skeleton-metrics">
				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className="weekly-skeleton-metric">
						<span className="skeleton skeleton-line" style={{ width: "45%", height: 26, margin: "0 auto 8px" }} />
						<span className="skeleton skeleton-line sm" style={{ width: "70%", margin: "0 auto 5px" }} />
						<span className="skeleton skeleton-line sm" style={{ width: "45%", margin: "0 auto" }} />
					</div>
				))}
			</div>

			{Array.from({ length: 3 }).map((_, i) => (
				<div key={i} className="weekly-skeleton-section">
					<span className="skeleton skeleton-line" style={{ width: 170, height: 13, marginBottom: 12 }} />
					{Array.from({ length: 3 }).map((__, j) => (
						<div key={j} className="weekly-skeleton-row">
							<span className="skeleton skeleton-line sm" style={{ width: `${40 + ((i * 7 + j * 11) % 25)}%` }} />
							<span className="skeleton skeleton-line sm" style={{ width: "18%" }} />
						</div>
					))}
				</div>
			))}
		</div>
	);
}
